// Libs
import classNames from 'classnames/bind';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
// Components, Layouts, Pages
import { BaseCheckbox } from '~/components/common';
// Others
import { IFormInventory } from '~/utils/interface/inventory';
// Styles, images, icons
import styles from './ProductOptionInventoryForm.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const ProductOptionInventoryForm = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/inventory', 'common/base']);

  const {
    control,
    watch,
    reset,
    formState: { errors },
  } = useFormContext<IFormInventory>();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Stack id='productOptionInventoryFormComponent' gap={4}>
      <Typography className={cx('header')}>{t('inventory_form_title_product_options')}</Typography>

      <Controller
        name='isDamageWaiver'
        control={control}
        render={({ field: { value, onChange } }) => (
          <BaseCheckbox
            label={t('inventory_form_title_damage_waiver')}
            checked={value}
            onChange={(value) => onChange(value)}
          />
        )}
      />

      <Controller
        name='isDiscountable'
        control={control}
        render={({ field: { value, onChange } }) => (
          <BaseCheckbox
            label={t('inventory_form_title_discountable')}
            checked={value}
            onChange={(value) => onChange(value)}
          />
        )}
      />

      <Controller
        name='isTaxable'
        control={control}
        render={({ field: { value, onChange } }) => (
          <BaseCheckbox
            label={t('inventory_form_title_taxable')}
            checked={value}
            onChange={(value) => onChange(value)}
          />
        )}
      />

      <Controller
        name='isShowOnPrint'
        control={control}
        render={({ field: { value, onChange } }) => (
          <BaseCheckbox
            label={t('inventory_form_title_show_on_print')}
            checked={value}
            onChange={(value) => onChange(value)}
          />
        )}
      />

      <Controller
        name='isAddOn'
        control={control}
        render={({ field: { value, onChange } }) => (
          <BaseCheckbox
            label={t('inventory_form_title_add_only_checkbox')}
            checked={value}
            onChange={(value) => onChange(value)}
          />
        )}
      />
    </Stack>
  );
};

export default ProductOptionInventoryForm;
